import type { Special } from "@/types";

export const specialList: Special[] = [
  {
    id: "special-1",
    title: "星际远征：太空题材动画精选",
    cover:
      "https://readdy.ai/api/search-image?query=wide%20banner%20of%20a%20fleet%20of%20starships%20sailing%20through%20a%20deep%20colorful%20nebula%2C%20orange%20and%20teal%20cosmic%20tones%2C%20clean%20minimal%20background%2C%20modern%20anime%20illustration%2C%20high%20detail&width=800&height=500&seq=special-cover-01&orientation=landscape",
    intro:
      "当人类的脚步迈向深空，故事便有了无限可能。本专题精选太空与星际题材作品，带你漫游无垠宇宙。",
    reason:
      "从星图谜题到废土废城，太空题材总能以最浪漫的方式讲述孤独与陪伴。适合喜欢宏大世界观与细腻情感的观众。",
    animeIds: ["anime-1", "anime-3", "anime-12"],
    newsIds: ["news-1", "news-3", "news-11"],
    characterIds: ["char-1", "char-2", "char-4", "char-8"],
    publishTime: "2025-10-01",
  },
  {
    id: "special-2",
    title: "剑与翼：奇幻战斗名作巡礼",
    cover:
      "https://readdy.ai/api/search-image?query=epic%20fantasy%20banner%20of%20a%20winged%20knight%20and%20a%20swordswoman%20standing%20under%20a%20flaming%20orange%20sky%2C%20clean%20minimal%20background%2C%20modern%20anime%20illustration%2C%20high%20detail&width=800&height=500&seq=special-cover-02&orientation=landscape",
    intro:
      "刀光与羽翼交错的世界里，每一次挥剑都是对信念的确认。本专题汇聚奇幻战斗类高人气作品。",
    reason:
      "如果你热爱酣畅淋漓的战斗演出与经得起推敲的成长弧线，这份片单不会让你失望。",
    animeIds: ["anime-2", "anime-4", "anime-8", "anime-10"],
    newsIds: ["news-2", "news-5", "news-7"],
    characterIds: ["char-3", "char-6", "char-11"],
    publishTime: "2025-09-15",
  },
  {
    id: "special-3",
    title: "治愈时刻：深夜想看的温柔故事",
    cover:
      "https://readdy.ai/api/search-image?query=cozy%20warm%20banner%20of%20a%20lit%20bakery%20window%20and%20tea%20cup%20at%20night%2C%20soft%20peach%20and%20orange%20glow%2C%20clean%20minimal%20background%2C%20healing%20anime%20illustration%2C%20high%20detail&width=800&height=500&seq=special-cover-03&orientation=landscape",
    intro:
      "有些作品不需要跌宕起伏，只想安静地陪你坐一会儿。精选治愈系入门与进阶之选。",
    reason:
      "忙碌了一天，你需要一点不费力的温柔。这些故事节奏舒缓、情绪真诚，适合睡前慢慢看。",
    animeIds: ["anime-6", "anime-9", "anime-11", "anime-13"],
    newsIds: ["news-6", "news-10", "news-12"],
    characterIds: ["char-7", "char-9", "char-12"],
    publishTime: "2025-08-28",
  },
  {
    id: "special-4",
    title: "时间的形状：悬疑与思考特辑",
    cover:
      "https://readdy.ai/api/search-image?query=mysterious%20banner%20of%20a%20lone%20figure%20among%20floating%20glowing%20clock%20fragments%2C%20teal%20and%20orange%20contrast%2C%20clean%20minimal%20background%2C%20modern%20anime%20illustration%2C%20high%20detail&width=800&height=500&seq=special-cover-04&orientation=landscape",
    intro:
      "当时间、记忆与真相彼此缠绕，故事便有了让人反复回味的重量。本专题聚焦悬疑与哲思题材。",
    reason:
      "如果你喜欢在剧情里抽丝剥茧，也享受看完后久久不能平静的感觉，这几部值得细品。",
    animeIds: ["anime-5", "anime-7", "anime-14", "anime-15"],
    newsIds: ["news-3", "news-8"],
    characterIds: ["char-5", "char-10"],
    publishTime: "2025-08-10",
  },
];